(() => {
  const bannerManager = {
    dom: {
      selectors: {
        productButton: ".product__btn-wrapper",
        banner: ".banner",
        bannerContent: ".banner__content",
        plusIcon: ".product__icon-plus",
      },

      getProductButtons: () =>
        document.querySelectorAll(bannerManager.dom.selectors.productButton),

      getBanner: () =>
        document.querySelector(bannerManager.dom.selectors.banner),

      getBannerContent: () =>
        document.querySelector(bannerManager.dom.selectors.bannerContent),

      getPlusIcons: () =>
        document.querySelectorAll(bannerManager.dom.selectors.plusIcon),
    },

    init: () => {
      const productButtonRefs = bannerManager.dom.getProductButtons();
      const bannerRef = bannerManager.dom.getBanner();
      const bannerContentRef = bannerManager.dom.getBannerContent();
      const plusIconRefs = bannerManager.dom.getPlusIcons();

      const contentMarkup = bannerContentRef.innerHTML;

      const changeAllIconsToPlus = () => {
        plusIconRefs.forEach((icon) => icon.classList.add("visible-icon"));
      };

      const generateProductMarkup = ({ currentTarget }) => {
        const { id } = currentTarget.dataset;
        const { product_id: contentId } = bannerContentRef.dataset;

        const productRef = document.querySelector(
          `.product__info[data-id="${id}"]`
        );
        const minusIconRef = currentTarget.querySelector(
          ".product__icon-minus"
        );
        const plusIconRef = currentTarget.querySelector(".product__icon-plus");

        if (id === contentId) {
          bannerContentRef.innerHTML = contentMarkup;
          bannerContentRef.dataset.product_id = "";

          plusIconRef.classList.add("visible-icon");
          minusIconRef.classList.remove("visible-icon");
          bannerRef.classList.add("default");
          return;
        }

        const productMarkup = productRef.innerHTML;
        bannerContentRef.innerHTML = productMarkup;
        bannerContentRef.dataset.product_id = id;

        changeAllIconsToPlus();
        plusIconRef.classList.remove("visible-icon");
        minusIconRef.classList.add("visible-icon");
        bannerRef.classList.remove("default");
      };

      productButtonRefs.forEach((button) => {
        button.addEventListener("click", generateProductMarkup);
      });
    },
  };

  bannerManager.init();
})()

